import { Endpoint } from "../../enpoints.types"

type ItemTypes = "bonus" | "fine"

export const presetItemsEndpoint: Record<ItemTypes, Endpoint> = {
  bonus: Endpoint.TEACHER_ADMIN_BONUSES,
  fine: Endpoint.TEACHER_ADMIN_FINES,
}
